var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid",
      attrs: { id: "notificationsAccountSettings" }
    },
    [
      _c("div", { staticClass: "notification-save-header" }, [
        _c(
          "button",
          { staticClass: "btn unstyled", on: { click: _vm.save } },
          [
            _c("font-awesome-icon", { attrs: { icon: "save" } }),
            _vm._v(" " + _vm._s(_vm.$t("commonText.save")) + "\n\t\t")
          ],
          1
        )
      ]),
      _vm._v(" "),
      !!_vm.responseMessage
        ? _c(
            "div",
            {
              staticClass: "alert",
              class: {
                "alert-success": _vm.responseType === "success",
                "alert-danger": _vm.responseType === "danger"
              },
              staticStyle: { "margin-top": "10px" }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.responseMessage) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dataIsLoaded
        ? [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("h4", { staticClass: "text-blue" }, [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "MAIN_CONTENT.Notifications.receiveNotificationsForTheFollowing"
                        )
                      ) +
                      "\n\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "MAIN_CONTENT.Notifications.turnOffNotificationsViaEmail"
                        )
                      ) +
                      "\n\t\t\t\t"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-xs-6 col-lg-4",
                  staticStyle: { "font-weight": "bold" }
                },
                [
                  _c("sapphire-toggle", {
                    attrs: {
                      value:
                        _vm.preferences.PREFERENCES
                          .RECEIVE_BULLETIN_EMAIL_ALERTS,
                      cssColors: true,
                      label: _vm.$t(
                        "MAIN_CONTENT.Notifications.districtAnnouncements"
                      )
                    },
                    on: { input: _vm.setPageDirty },
                    model: {
                      value:
                        _vm.preferences.PREFERENCES
                          .RECEIVE_BULLETIN_EMAIL_ALERTS,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.preferences.PREFERENCES,
                          "RECEIVE_BULLETIN_EMAIL_ALERTS",
                          $$v
                        )
                      },
                      expression:
                        "preferences.PREFERENCES.RECEIVE_BULLETIN_EMAIL_ALERTS"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-xs-6 col-lg-4",
                  staticStyle: { "font-weight": "bold" }
                },
                [
                  _c("sapphire-toggle", {
                    attrs: {
                      value:
                        _vm.preferences.PREFERENCES.RECEIVE_REPORT_EMAIL_ALERTS,
                      cssColors: true,
                      label: _vm.$t(
                        "MAIN_CONTENT.Notifications.studentClassReports"
                      )
                    },
                    on: { input: _vm.setPageDirty },
                    model: {
                      value:
                        _vm.preferences.PREFERENCES.RECEIVE_REPORT_EMAIL_ALERTS,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.preferences.PREFERENCES,
                          "RECEIVE_REPORT_EMAIL_ALERTS",
                          $$v
                        )
                      },
                      expression:
                        "preferences.PREFERENCES.RECEIVE_REPORT_EMAIL_ALERTS"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            !!_vm.options.GLOBAL_SETTINGS && _vm.options.GLOBAL_SETTINGS.length
              ? _c("shared-notifications", {
                  attrs: {
                    options: _vm.options,
                    preferences: _vm.preferences,
                    steps: _vm.steps,
                    broadcast: _vm.broadcasts,
                    globalSetting: _vm.globalSetting,
                    userType: _vm.role,
                    broadcastsData: _vm.broadcasts,
                    globalSettingText: _vm.$t(
                      "MAIN_CONTENT.Notifications.globalSetting"
                    ),
                    emailText: _vm.$t("MAIN_CONTENT.Notifications.email"),
                    voiceCallText: _vm.$t(
                      "MAIN_CONTENT.Notifications.voiceCall"
                    ),
                    smsText: _vm.$t("MAIN_CONTENT.Notifications.sms"),
                    notificationsText: _vm.$t(
                      "MAIN_CONTENT.Notifications.notificationsText"
                    ),
                    subscribedText: _vm.$t(
                      "MAIN_CONTENT.Notifications.subscribed"
                    ),
                    languageSettinsText: _vm.$t(
                      "MAIN_CONTENT.Notifications.languageSettings"
                    ),
                    addNewStepText: _vm.$t(
                      "MAIN_CONTENT.Notifications.addNewStep"
                    ),
                    defaultVoiceText: _vm.$t(
                      "MAIN_CONTENT.Notifications.defaultVoiceText"
                    ),
                    defaultSMSText: _vm.$t(
                      "MAIN_CONTENT.Notifications.defaultSMSText"
                    ),
                    defaultEmailText: _vm.$t(
                      "MAIN_CONTENT.Notifications.defaultEmailText"
                    ),
                    broadcastHistoryText: _vm.$t(
                      "MAIN_CONTENT.Notifications.broadcastHistoryText"
                    ),
                    noBroadcastMessage: _vm.$t(
                      "MAIN_CONTENT.Notifications.noBroadcastMessage"
                    ),
                    phoneText: _vm.$t("MAIN_CONTENT.Notifications.phone"),
                    answeredByText: _vm.$t(
                      "MAIN_CONTENT.Notifications.answeredBy"
                    ),
                    durationsText: _vm.$t(
                      "MAIN_CONTENT.Notifications.duration"
                    ),
                    phoneMessageText: _vm.$t(
                      "MAIN_CONTENT.Notifications.phoneMessage"
                    ),
                    showEnglishText: _vm.$t(
                      "MAIN_CONTENT.Notifications.showEnglish"
                    ),
                    noAudioSupportText: _vm.$t(
                      "MAIN_CONTENT.Notifications.noAudioSupport"
                    ),
                    smsTextMessage: _vm.$t(
                      "MAIN_CONTENT.Notifications.smsTextMessage"
                    ),
                    smsTestMessageColon: _vm.$t(
                      "MAIN_CONTENT.Notifications.smsTextMessageWithColon"
                    ),
                    emailAllCaps: _vm.$t(
                      "MAIN_CONTENT.Notifications.emailAllCaps"
                    ),
                    emailWithColon: _vm.$t(
                      "MAIN_CONTENT.Notifications.emailWithColon"
                    ),
                    subjectLineWithColon: _vm.$t(
                      "MAIN_CONTENT.Notifications.subjectLineWithColon"
                    ),
                    notificationsTabName: _vm.$t(
                      "MAIN_CONTENT.Notifications.notificationsTabName"
                    ),
                    broadcastsTabName: _vm.$t(
                      "MAIN_CONTENT.Notifications.broadcastsTabName"
                    ),
                    defaultWorkflowText: _vm.$t(
                      "MAIN_CONTENT.Notifications.defaultNotifications"
                    ),
                    systemDefaultText: _vm.$t(
                      "MAIN_CONTENT.Notifications.systemDefault"
                    ),
                    systemDefaultMessageText: _vm.$t(
                      "MAIN_CONTENT.Notifications.systemDefaultMessageText"
                    ),
                    myDefaultText: _vm.$t(
                      "MAIN_CONTENT.Notifications.myDefault"
                    ),
                    myDefaultMessageText: _vm.$t(
                      "MAIN_CONTENT.Notifications.myDefaultMessageText"
                    ),
                    customText: _vm.$t("MAIN_CONTENT.Notifications.custom"),
                    customMessageText: _vm.$t(
                      "MAIN_CONTENT.Notifications.customMessage"
                    ),
                    addVoiceCallText: _vm.$t(
                      "MAIN_CONTENT.Notifications.addVoiceCall"
                    ),
                    contactAtText: _vm.$t(
                      "MAIN_CONTENT.Notifications.contactAt"
                    ),
                    addEmailText: _vm.$t("MAIN_CONTENT.Notifications.addEmail"),
                    addSMSTextMessageText: _vm.$t(
                      "MAIN_CONTENT.Notifications.addSMSTextMessage"
                    )
                  },
                  on: {
                    changeGlobal: _vm.changeGlobalSetting,
                    setDirty: _vm.setPageDirty
                  }
                })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }